import { jsx, jsxs } from "react/jsx-runtime";
import { GlobalStyles } from "@mui/material";
import { lazy, Suspense, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { validateTidalLicense } from "../base/index.js";
import { TidalThemeProvider } from "../styles/index.js";
import {
  coverageRootId,
  TIDAL_TELEMETRY,
  telemetryEngine
} from "../telemetry/engine/index.js";
import { useMonitorUrl } from "./useMonitorUrl.js";
const CoverageUI = lazy(() => import("../telemetry/coverage-ui/index.js"));
const telemetryGlobalStyle = /* @__PURE__ */ jsx(
  GlobalStyles,
  {
    styles: (theme) => ({
      ":root": {
        "--tidal-coverage-mui": theme.palette.info.main,
        "--tidal-coverage-other": theme.palette.warning.main,
        "--tidal-coverage-tidal": theme.palette.success.main
      }
    })
  }
);
function TelemetryRoot(props) {
  const { product, env, enableTelemetry } = props;
  const [render, setRender] = useState(false);
  useEffect(() => {
    telemetryEngine.setLicenseInfo({ env, product });
  }, [product, env]);
  useMonitorUrl(enableTelemetry);
  useEffect(() => {
    function listener(event) {
      if (typeof event.data === "object") {
        if (event.data.source === TIDAL_TELEMETRY) {
          const msg = event.data;
          switch (msg.action) {
            case "showUI":
              setRender(true);
              break;
            case "hideUI":
              setRender(false);
              break;
            case "toggleUI":
              setRender((current) => !current);
              break;
          }
        }
      }
    }
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
      setRender(false);
    };
  }, []);
  if (!render) {
    return null;
  }
  return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsxs(TidalThemeProvider, { children: [
    telemetryGlobalStyle,
    /* @__PURE__ */ jsx(CoverageUI, {})
  ] }) });
}
function mountTelemetryRoot(options) {
  const { product, env, enableTelemetry = false } = options;
  try {
    if (document.getElementById(coverageRootId)) return;
    const rootElement = document.createElement("div");
    rootElement.id = coverageRootId;
    rootElement.style.margin = "0px";
    rootElement.style.padding = "0px";
    rootElement.style.zIndex = "1000000";
    rootElement.dataset.tidal = "coverage-root";
    rootElement.dataset.product = product;
    if (env) rootElement.dataset.env = env;
    document.body.prepend(rootElement);
    createRoot(rootElement).render(/* @__PURE__ */ jsx(TelemetryRoot, { ...options }));
  } catch (e) {
    if (e instanceof Error) {
      console.log("Error mounting coverage root", e.message);
    } else {
      console.log("Unknown error mounting coverage root");
    }
  }
}
validateTidalLicense();
export {
  TelemetryRoot,
  mountTelemetryRoot
};
//# sourceMappingURL=Telemetry.js.map
